import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import {
  EditNoteRequestPayload,
  Note
} from '../../types'

export type GetNotesQueryPaylod = {
  userId?: string
  limit?: string
}

export const notesApi = createApi({
  reducerPath: 'notesApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Notes'],
  endpoints: (builder) => ({
    getNotes: builder.query<Note[], GetNotesQueryPaylod>({
      query: (query: GetNotesQueryPaylod) => ({
        url: generateUrl(query),
      }),
      providesTags: ['Notes'],
    }),
    getNoteById: builder.query<Note, string>({
      query: (id: string) => ({
        url: `${CONSTANTS.API.NOTES}/${id}`,
      }),
      providesTags: ['Notes'],
    }),
    createNote: builder.mutation({
      query: (payload: Note) => ({
        url: CONSTANTS.API.NOTES,
        method: 'POST',
        body: payload,
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
        },
      }),
      invalidatesTags: ['Notes'],
    }),
    editNote: builder.mutation({
      query: (payload: EditNoteRequestPayload) => {
        return {
          url: `${CONSTANTS.API.NOTES}/${payload.id}`,
          method: 'PATCH',
          body: payload,
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        }
      },
    }),
    deleteNote: builder.mutation<Note, string>({
      query: (id: string) => ({
        url: `${CONSTANTS.API.NOTES}/${id}`,
        method: 'DELETE'
      }),
    }),
  }),
})

const generateUrl = (queryParams: GetNotesQueryPaylod) => {
  let query = new URLSearchParams(queryParams).toString()
  query = query.replace('undefined', '')
  return `${CONSTANTS.API.NOTES}${query.length > 0 ? '?' : ''}${query}`
}

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetNotesQuery,
  useGetNoteByIdQuery,
  useCreateNoteMutation,
  useEditNoteMutation,
  useDeleteNoteMutation
} = notesApi
